/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import ComponentBase from '../Utility/ComponentBase';
import CLog, { LogTypes } from '../Utility/ComponentLogger';
import LocalizationComponent from './LocalizationComponent';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** [[Local]] handler for cc.Sprite's to respond to Localization setting changes. */
@cc._decorator.ccclass
@cc._decorator.requireComponent(cc.Sprite)
export default class LocalSpriteComponent extends ComponentBase
{
    /** Sprite attached to this component. */
    protected sprite: cc.Sprite = null;
    /** Texture used in-editor. */
    protected defaultTexture: cc.Texture2D = null;

    /** URL parts to create localized path. */
    protected path: string[] = [];

    /** @hidden */
    private _localRef: InjectableComponent<LocalizationComponent> = new InjectableComponent();

    protected setContexts(): void
    {
        super.setContexts();
        this._localRef.SetContext(LocalizationComponent);
    }

    /** @hidden */
    protected onLoad(): void
    {
        super.onLoad();

        this.sprite = this.getComponent(cc.Sprite);

        if (!this.sprite)
        {
            this.enabled = false;
            CLog.error('No sprite component.', this, LogTypes.Localization);
        }
    }

    /** @hidden */
    protected start(): void
    {
        super.start();

        if (!this._localRef.HasValue())
        {
            CLog.error('LocalizationComponent failed to inject.', this, LogTypes.Initialization);
            return;
        }

        this._localRef.Value.OnChanged(() => this.onCultureChanged());
        this.defaultTexture = this.sprite.spriteFrame.getTexture();

        this.path = this.defaultTexture.url.split(this._localRef.Value.CultureKey);

        if (!this.path || this.path.length < 2)
        {
            CLog.error('Invalid url.', this, LogTypes.Localization);
            return;
        }
    }

    /** @hidden */
    private onCultureChanged(): void
    {
        const url: string = this.path.join(this._localRef.Value.CultureKey);

        this.sprite.spriteFrame.setTexture(url);

        // Texture isn't immediately loaded on first attempt.
        this.scheduleOnce(() =>
        {
            if (!this.sprite.spriteFrame.textureLoaded())
            {
                this.resetTexture();
            }
        }, .1);
    }

    /** Sets sprite frame texture back to default. */
    private resetTexture(): void
    {
        this.sprite.spriteFrame.setTexture(this.defaultTexture);
    }
}
